<section>
    <ng-content></ng-content>
</section>
<ng-container *ngIf="state === 'success' && maxPage > 1">
    <ng-container *ngTemplateOutlet="nav;"></ng-container>
</ng-container>
<input type="number"
       hidden
       name="page"
       [attr.value]="1">
<!--  -->
<!--  -->
<!--  -->
<ng-template #nav>
    <nav [attr.aria-label]="'PAGINATION.GROUP' | translate">
        <button type="button"
                (click)="updateUrl(prev)"
                tick
                [attr.aria-label]="'PAGINATION.GO_TO' | translate:{page:prev}"
                *ngIf="_from > 0">
            <span>
                <svg xmlns="http://www.w3.org/2000/svg"
                     aria-hidden="true"
                     width="26"
                     height="26"
                     fill="currentColor"
                     viewBox="0 -960 960 960">
                     <path d="M400-240 160-480l240-240 56 58-142 142h486v80H314l142 142-56 58Z"/>
                </svg>
            </span>
        </button>
        <button type="button"
                (click)="updateUrl(1)"
                [attr.next]="1"
                [attr.aria-label]="'PAGINATION.GO_TO' | translate:{page:1}"
                *ngIf="_from > 0"><span>{{1}}</span></button>
        <p *ngIf="current >  (navigateablePages.length + 3) / 2">&#8230;</p>
        <button type="button"
                (click)="updateUrl(page )"
                [attr.next]="page"
                [attr.selected]="page === current ? '' : null"
                [attr.aria-label]="'PAGINATION.GO_TO' | translate:{page:(page)}"
                *ngFor="let page of navigateablePages"><span>{{ page }}</span></button>
        <p *ngIf="current + (navigateablePages.length + 1) / 2 < maxPage">&#8230;</p>
        <button type="button"
                (click)="updateUrl(maxPage)"
                [attr.next]="maxPage"
                [attr.at-last]="navigateablePages[navigateablePages.length -1] == maxPage ? '' : null"
                [attr.aria-label]="'PAGINATION.GO_TO' | translate:{page:maxPage }"
                *ngIf="_from + _size < _max"><span>{{maxPage}}</span></button>
        <button type="button"
                (click)="updateUrl(next)"
                tick
                [attr.aria-label]="'PAGINATION.GO_TO' | translate:{page:next}"
                *ngIf="_from + _size < _max">
            <span>
                <svg xmlns="http://www.w3.org/2000/svg"
                     aria-hidden="true"
                     width="26"
                     height="26"
                     fill="currentColor"
                     viewBox="0 -960 960 960">
                     <path d="m560-240-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240Z"/>
                </svg>
            </span>
        </button>
    </nav>
</ng-template>
